var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BigNumber from 'bignumber.js';
import { getNaviFlashLoanSupportedCoinTypes, getNaviFlashLoanFeeForCoinType } from 'alphalend-sdk';
const TTL_MS = 60000; // 60s - matches SDK cacheTime
let cachedSet = null;
let cachedSetExpiresAt = 0;
let fetchPromise = null;
function normalize(coinType) {
    return coinType.replace(/^0x0+/, '0x').toLowerCase();
}
export function fetchNaviFlashLoanSupportedSet() {
    return __awaiter(this, void 0, void 0, function* () {
        if (cachedSet != null && Date.now() <= cachedSetExpiresAt)
            return cachedSet;
        if (fetchPromise)
            return fetchPromise;
        fetchPromise = getNaviFlashLoanSupportedCoinTypes({ cacheTime: TTL_MS })
            .then((set) => {
            cachedSet = set;
            cachedSetExpiresAt = Date.now() + TTL_MS;
            fetchPromise = null;
            return set;
        })
            .catch((err) => {
            fetchPromise = null;
            throw err;
        });
        return fetchPromise;
    });
}
export function getFlashRepaySupported(coinType) {
    if (!cachedSet || Date.now() > cachedSetExpiresAt)
        return undefined;
    return cachedSet.has(normalize(coinType));
}
export function toRepayAmountBaseUnits(amount, expo) {
    if (!amount || parseFloat(amount) <= 0)
        return undefined;
    return BigInt(Math.floor(parseFloat(amount) * Math.pow(10, expo))).toString();
}
export function getMaxRepayByCollateral(selectedCollateral, repayPrice, borrowedBalance, feeDecimal) {
    if ((selectedCollateral === null || selectedCollateral === void 0 ? void 0 : selectedCollateral.usdValueNum) == null || feeDecimal == null)
        return '';
    const dSuppliedValueUsd = new BigNumber(selectedCollateral.usdValueNum);
    const feeMultiplier = 1 + feeDecimal;
    const dMaxRepayValueUsd = dSuppliedValueUsd.div(String(feeMultiplier));
    const dPrice = new BigNumber(repayPrice);
    const dBorrowed = new BigNumber(borrowedBalance);
    if (dPrice.lte(0))
        return dBorrowed.gt(0) ? dBorrowed.toFixed() : '';
    const dMaxByCollateral = BigNumber.min(dMaxRepayValueUsd.div(dPrice), dBorrowed);
    return dMaxByCollateral.gte(0) ? dMaxByCollateral.toFixed() : '';
}
export function fetchNaviFlashLoanFeeForCoinType(coinType) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!coinType)
            return null;
        return getNaviFlashLoanFeeForCoinType(coinType, { cacheTime: TTL_MS });
    });
}
